import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0610449e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-list-group" }
const _hoisted_2 = { class: "color-success" }

import { Category } from '@/types/category'
import CategoryList from "@/components/common/categories/CategoryList.vue"
import { ref } from "vue"

interface Props {
  categories: Category[];
  modelValue: Category;
}
// const props = defineProps<Props>();
interface Emits {
  (e: 'listClick', value: Category): void
  (e: 'update:modelValue', value: Category): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    categories: { type: Array, required: true },
    modelValue: { type: null, required: true }
  },
  emits: ["listClick", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'listClick', value: Category): void
  (e: 'update:modelValue', value: Category): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  categories: Category[];
  modelValue: Category;
}



const categoryListVisible = ref(false)
// const selectName = ref("All")
const handleNodeClick = (data: Category) => {
  // selectName.value = data.name
  categoryListVisible.value = false;
  emit('update:modelValue', data)
  // emit("listClick", data)
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (categoryListVisible.value = !categoryListVisible.value)),
      type: "text"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, "カテゴリ選択:" + _toDisplayString(__props.modelValue.name), 1)
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(CategoryList, {
      class: "category-list",
      onListClick: handleNodeClick,
      categories: __props.categories
    }, null, 8, ["categories"]), [
      [_vShow, categoryListVisible.value]
    ])
  ]))
}
}

})